type FiscalMonthDay = {
  month: number
  day: number
}

export type ScorecardDefaultDates = {
  startDate: string
  targetDate: string
}

function toIsoDate(date: Date) {
  return date.toISOString().slice(0, 10)
}

export function toLocalIsoDate(date = new Date()) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

function isValidMonthDay(month: number, day: number) {
  if (!Number.isInteger(month) || !Number.isInteger(day)) return false

  const date = new Date(Date.UTC(2000, month - 1, day))
  return date.getUTCMonth() === month - 1 && date.getUTCDate() === day
}

function parseFiscalMonthDay(
  fiscalYearEnd?: string | null
): FiscalMonthDay | null {
  if (!fiscalYearEnd) return null

  const match = fiscalYearEnd.match(/^(?:\d{4}-)?(\d{1,2})-(\d{1,2})(?:T.*)?$/)
  if (!match) return null

  const month = Number(match[1])
  const day = Number(match[2])

  return isValidMonthDay(month, day) ? { month, day } : null
}

function buildFiscalYearEndDate(year: number, month: number, day: number) {
  const lastDayOfMonth = new Date(Date.UTC(year, month, 0)).getUTCDate()
  return new Date(Date.UTC(year, month - 1, Math.min(day, lastDayOfMonth)))
}

export function getScorecardDefaultDates(
  fiscalYearEnd?: string | null,
  today = new Date()
): ScorecardDefaultDates {
  const fiscalMonthDay = parseFiscalMonthDay(fiscalYearEnd) ?? {
    month: 12,
    day: 31,
  }
  const todayUtc = new Date(
    Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())
  )
  let targetYear = today.getFullYear()
  let targetDate = buildFiscalYearEndDate(
    targetYear,
    fiscalMonthDay.month,
    fiscalMonthDay.day
  )

  if (targetDate < todayUtc) {
    targetYear += 1
    targetDate = buildFiscalYearEndDate(
      targetYear,
      fiscalMonthDay.month,
      fiscalMonthDay.day
    )
  }

  const priorFiscalYearEnd = buildFiscalYearEndDate(
    targetYear - 1,
    fiscalMonthDay.month,
    fiscalMonthDay.day
  )
  priorFiscalYearEnd.setUTCDate(priorFiscalYearEnd.getUTCDate() + 1)

  return {
    startDate: toIsoDate(priorFiscalYearEnd),
    targetDate: toIsoDate(targetDate),
  }
}
